import React, { createContext, useContext, useState, useEffect } from 'react';

// Create context with default values
const RxUserContext = createContext({
  user: null,
  setUser: () => {},
  isLoggedIn: false,
  setIsLoggedIn: () => {},
  loading: true,
});

// Provider component
export const RxUserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage on initial render
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('currentUser');
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        setIsLoggedIn(true);
      }
    } catch (error) {
      console.error('Error loading user from localStorage:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const value = {
    user,
    setUser,
    isLoggedIn,
    setIsLoggedIn,
    loading,
  };

  return (
    <RxUserContext.Provider value={value}>
      {children}
    </RxUserContext.Provider>
  );
};

// Custom hook for using this context
export const useRxUser = () => {
  const context = useContext(RxUserContext);
  if (context === undefined) {
    throw new Error('useRxUser must be used within a RxUserProvider');
  }
  return context;
};

export default RxUserContext; 